import { WorkingStepIconSvg } from 'components/Common/WorkingSteps/WorkingStepIcon'
import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from 'recharts'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'
import { TargetPriceTooltipTypes } from './Tooltips/TargetPriceTooltip'
import { TargetPriceGraphData } from '../useBomItemDetails'

export const XAxisTick = (props: {
  x?: number
  y?: number
  payload?: { value: WorkingStepType; index: number }
  getDataByIndex: (index: number) => TargetPriceGraphData
  onMouseEnter: (
    e: MouseEvent,
    data: TargetPriceGraphData,
    tooltipDataType: TargetPriceTooltipTypes
  ) => void
}) => {
  // console.log(props)
  const { getDataByIndex, onMouseEnter, payload, ...rest } = props
  const data: TargetPriceGraphData = getDataByIndex(props.payload.index)
  const { t } = useTranslation()

  if (data.primaryWorkingStep) {
    return (
      <g
        onMouseEnter={(e) => onMouseEnter(e, data, 'WorkingStepSummary')}
        onMouseLeave={(e) => onMouseEnter(e, undefined, 'WorkingStepSummary')}
      >
        <WorkingStepIconSvg
          attributes={{
            x: props.x - 16,
            y: props.y - 12,
            height: 32,
            width: 32,
          }}
          disableTitle
          workingStepType={payload.value}
        ></WorkingStepIconSvg>
        {/* <Text {...props} y={props.y + 24} width={24}>
              {props.getDataByIndex(props.payload.index).resource}
            </Text> */}
      </g>
    )
  } else {
    return (
      <g
        onMouseEnter={(e) =>
          data &&
          onMouseEnter(e, data, data.childrens ? 'ChildrenSummary' : 'Total')
        }
        onMouseLeave={(e) => onMouseEnter(e, undefined, 'ChildrenSummary')}
      >
        <Text {...rest} fill="currentColor" y={props.y + 16}>
          {t(`project:${payload.value}`, payload.value)}
        </Text>
      </g>
    )
  }
}
